import React, { FunctionComponent } from "react";
import { useIntl } from "react-intl";
import {
  BsBellSlashFill,
} from "react-icons/bs";
import {
  ButtonProps,
  IconButton,
} from "@chakra-ui/react";

import { useUserPreference } from "common/user-preferences";


interface IProps extends ButtonProps {
  bg: string;
  hoverBg?: string;
}


const MuteButton: FunctionComponent<IProps> = ({
  bg,
  hoverBg,
  ...rest
}) => {
  const intl = useIntl();
  const [ mutedAlerts, muteAlerts ] = useUserPreference<boolean>("ui__muted_alerts");

  return (
    <>
      <IconButton
        aria-label="Mute button"
        icon={<BsBellSlashFill/>}
        bg={bg}
        color="red.500"
        _hover={hoverBg ? { bg: hoverBg } : undefined}
        onClick={() => muteAlerts(!mutedAlerts)}
        title={
          mutedAlerts
          ? intl.formatMessage({
            id: "alarms__alerts__unmute",
            defaultMessage: "Unmute alerts",
          })
          : intl.formatMessage({
            id: "alarms__alerts__mute",
            defaultMessage: "Mute alerts",
          })
        }
        {...rest}
      />
    </>
  );
};

export default MuteButton;
